import { buildRouteTree } from "utils/routeUtils";

export const routes = buildRouteTree({
	team: null
});
